var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25Zm0 16.25c-4.133 0-7.5-3.367-7.5-7.5S5.867 2.5 10 2.5s7.5 3.367 7.5 7.5-3.367 7.5-7.5 7.5Zm.842-4.3a1.05 1.05 0 0 1-1.034 1.033c-.541 0-1.033-.458-1.025-1.033-.008-.558.459-1.017 1.025-1.017a1.03 1.03 0 0 1 1.034 1.017ZM12.8 8.008c0 .967-.517 1.55-1.275 2.009-.617.358-.908.708-.908 1.433v.158H8.942v-.158c0-1.375.35-1.8 1-2.208.5-.325.883-.642.891-1.142 0-.492-.4-.825-.891-.817-.484 0-.925.334-.934.909H7.2c.025-1.667 1.258-2.425 2.758-2.425 1.65 0 2.842.8 2.85 2.241H12.8Z",
    fill: "current"
  })));
};
export default SvgHelp;